import { Alert, AlertProps } from '@mui/material';
import { AttributionCriteria } from '../../../../types/Criteria/AttributionCriteria';

interface AttributionFilterAlertProps extends AlertProps {
    attributionCriteria: AttributionCriteria;
}

const AttributionFilterAlert = ({ attributionCriteria, ...props }: AttributionFilterAlertProps) => {
    const hasFilters =
        attributionCriteria.agencyIds.length > 0 ||
        attributionCriteria.advertiserIds.length > 0 ||
        attributionCriteria.oemIds.length > 0 ||
        attributionCriteria.oemProgramIds.length > 0 ||
        attributionCriteria.agencyMarketRegions.length > 0;

    if (hasFilters) {
        return <></>;
    }

    return (
        <Alert severity="info" {...props}>
            Looks like you have not selected any filters to find any attribution data.
        </Alert>
    );
};

export type { AttributionFilterAlertProps };
export default AttributionFilterAlert;
